// Centralized URL parameter definitions for modal triggers
export const URL_PARAMS = {
  // Modal triggers
  MODALS: {
    CREATE_PROJECT: 'create-project',
    CREATE_TASK: 'create-task', 
    CREATE_POST: 'create-post',
    // Future modal parameters can be added here
    EDIT_PROJECT: 'edit-project',
    EDIT_TASK: 'edit-task',
  },
  
  // Filters and views (for future use)
  FILTERS: {
    PROJECT_ID: 'project',
    TASK_STATUS: 'status',
    DATE_RANGE: 'range',
  },
  
  // Navigation state (for future use)
  NAVIGATION: {
    TAB: 'tab',
    VIEW: 'view',
    SECTION: 'section',
  }
} as const;

// Type safety for URL parameters
export type ModalParam = typeof URL_PARAMS.MODALS[keyof typeof URL_PARAMS.MODALS];
export type FilterParam = typeof URL_PARAMS.FILTERS[keyof typeof URL_PARAMS.FILTERS];
export type NavigationParam = typeof URL_PARAMS.NAVIGATION[keyof typeof URL_PARAMS.NAVIGATION]; 